/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Plan_Free_DescInputs */

const en_pricing_plan_free_desc = /** @type {(inputs: Pricing_Plan_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Get started with the basics.`)
};

const de_pricing_plan_free_desc = /** @type {(inputs: Pricing_Plan_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starte mit den Grundlagen.`)
};

const fr_pricing_plan_free_desc = /** @type {(inputs: Pricing_Plan_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commence par les bases.`)
};

const es_pricing_plan_free_desc = /** @type {(inputs: Pricing_Plan_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empiece con lo básico.`)
};

const it_pricing_plan_free_desc = /** @type {(inputs: Pricing_Plan_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia con le basi.`)
};

const nl_pricing_plan_free_desc = /** @type {(inputs: Pricing_Plan_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Begin met de basis.`)
};

const pl_pricing_plan_free_desc = /** @type {(inputs: Pricing_Plan_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zacznij od podstaw.`)
};

const fi_pricing_plan_free_desc = /** @type {(inputs: Pricing_Plan_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aloita perusteilla.`)
};

const da_pricing_plan_free_desc = /** @type {(inputs: Pricing_Plan_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom i gang med det grundlæggende.`)
};

const sv_pricing_plan_free_desc = /** @type {(inputs: Pricing_Plan_Free_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kom igång med grunderna.`)
};

/**
* | output |
* | --- |
* | "Get started with the basics." |
*
* @param {Pricing_Plan_Free_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_plan_free_desc = /** @type {((inputs?: Pricing_Plan_Free_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Plan_Free_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_plan_free_desc(inputs)
	if (locale === "fr") return fr_pricing_plan_free_desc(inputs)
	if (locale === "es") return es_pricing_plan_free_desc(inputs)
	if (locale === "it") return it_pricing_plan_free_desc(inputs)
	if (locale === "nl") return nl_pricing_plan_free_desc(inputs)
	if (locale === "pl") return pl_pricing_plan_free_desc(inputs)
	if (locale === "fi") return fi_pricing_plan_free_desc(inputs)
	if (locale === "da") return da_pricing_plan_free_desc(inputs)
	if (locale === "sv") return sv_pricing_plan_free_desc(inputs)
	return en_pricing_plan_free_desc(inputs)
});